import { Flex } from 'components/flex';
import { formatPrice } from 'utils/helpers';
import { InfoBlock } from 'components/info-block';

import * as Styles from './styles';
import { getReimbursementTotals } from './totals';

type Totals = ReturnType<typeof getReimbursementTotals>;

interface TileProps {
  title: string;
  value: string;
  caption?: string;
  emphasis?: boolean;
}

// One summary tile, in the app's info-card style (title, value, caption).
const Tile = ({ title, value, caption, emphasis }: TileProps) => (
  <Styles.Tile $emphasis={emphasis} data-testid="reimbursement-tile">
    <InfoBlock>
      <Flex gap={4} flexDirection="column">
        <Styles.TileTitle>{title}</Styles.TileTitle>
        <Styles.TileValue $emphasis={emphasis}>{value}</Styles.TileValue>
        {caption && <Styles.TileCaption>{caption}</Styles.TileCaption>}
      </Flex>
    </InfoBlock>
  </Styles.Tile>
);

// The tab's summary above the list: paid (with its prepaid part), pending,
// the total and how many records it covers. Not-approved and lost records
// are not counted.
export const ReimbursementSummary = ({ totals }: { totals: Totals }) => (
  <Styles.Summary data-testid="reimbursement-summary">
    <Tile
      title="Paid"
      value={formatPrice(totals.paid)}
      caption={
        totals.prepaid > 0
          ? `incl. ${formatPrice(totals.prepaid)} prepaid`
          : undefined
      }
    />
    <Tile title="Pending" value={formatPrice(totals.pending)} />
    <Tile emphasis title="Total" value={formatPrice(totals.total)} />
    <Tile
      title="Records"
      value={String(totals.counted)}
      caption="Not approved excluded"
    />
  </Styles.Summary>
);
